import React from 'react';
import { Route, Routes as Router } from 'react-router';
import {
  CREATE_FAIR_PAGE, DEVICE,
  FAIRS_DETAILS, FLOOR_PLANS_BASE,
  HALLS,
  HOME_PAGE,
} from './common/constants/routes.constants';
import FairHome from './pages/FairHome/FairHome';
import Layout from './layout';
import CreateFair from './pages/CreateFair/CreateFair';
import FairDetails from './pages/FairDetails/FairDetails';
import Halls from './pages/Halls/Halls';
import {Devices} from "./pages/Devices/DevicesCard/DevicesCard";
import {FloorPlansBase} from "./pages/FloorPlansBase/FloorPlansBase";

const Routes = () => {
  return (
    <Router>
      <Route element={<Layout />}>
        <Route element={<FairHome />} path={HOME_PAGE} />
        <Route element={<CreateFair />} path={CREATE_FAIR_PAGE} />
        <Route element={<FairDetails />} path={`${FAIRS_DETAILS}/:id`} />
        <Route element={<Halls />} path={HALLS} />
        <Route element={<Devices />} path={DEVICE} />
        <Route element={<FloorPlansBase />} path={FLOOR_PLANS_BASE} />
        {/*<Route element={<FloorDrawing />} path={FLOOR_DRAWING} />*/}
      </Route>
      {/*<Route element={<Login />} path={LOGIN} />*/}
      {/*<Route element={<NotFound />} path="*" />*/}
    </Router>
  );
};

export default Routes;
